// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2ea75068","239":"bbfd7c1c","455":"a3f8c424","977":"94dc4b95"}[chunkId] + ".chunk.js";
};